<template>
  <v-tabs show-arrows>
    <v-tab>Profile</v-tab>
    <v-tab> Plans </v-tab>
    <v-tab>Schools</v-tab>
    <v-tab>Client Chart</v-tab>
    <v-tab v-if="!isProvider">Case Notes</v-tab>
    <v-tab-item>
      <client-profile :client="client"></client-profile>
    </v-tab-item>
    <v-tab-item>
      <client-plans></client-plans>
    </v-tab-item>
    <v-tab-item>
      <client-schools-table></client-schools-table>
    </v-tab-item>
    <v-tab-item>
      <client-chart :client="client"></client-chart>
    </v-tab-item>
    <v-tab-item v-if="!isProvider">
      <case-notes></case-notes>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import ClientProfile from "../Details/client-profile";
import ClientPlans from "../Details/client-plans";
import ClientSchoolsTable from "../Details/client-schools-table";
import ClientChart from "./client-chart";
import CaseNotes from "./case-notes";
export default {
  props: ["client"],
  components: {
    ClientProfile,
    ClientPlans,
    ClientSchoolsTable,
    ClientChart,
    CaseNotes,
  },
  computed: {
    isProvider() {
      return this.$store.getters["securityModule/isProvider"];
    },
  },
};
</script>
